module.exports = __webpack_public_path__ + "img/tom-ford.404803b0.jpg";